// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"a390fc41","180":"bce86817","244":"fbfa66b6","280":"fd885b2a","453":"a71ef5e3","701":"cc795ef8","883":"03ce61a8"}[chunkId] + ".chunk.js";
};